<script>
	import SearchForm from './SearchForm.svelte'
	import { searchResults } from './stores.js'
	import { afterUpdate, onMount } from "svelte";
	import { formatSearchResults } from './js/localApiLookup.js';
	import { searchOptions } from './js/searchFunctions';
	import { buildCache } from './js/searchFunctions';

	searchResults.subscribe(value => {
		formatSearchResults(value);
	});
	onMount( () => buildCache());
</script>

<SearchForm searchOptions={searchOptions}/>

<queryResults>
	<div id='searchResults'>
	</div>
	<div id='infoboxes'>
	</div>
</queryResults>

<style>
	queryResults {
		width: 100%;
		display: block;
		margin-top: 5px;
	}

	#searchResults {
		float: left;
		padding-left: 1%;
		max-width: 30%;
		font-size: 20px;
	}

	#searchResults :global(div:hover) {
		background-color: rgba(0,0,0,0.1);
	}

	#infoboxes {
		float: right;
		text-align: left;
		width: 60%;
	}
</style>